<div class="modal-header">
  <button
    type="button"
    class="btn-close"
    (click)="bsModalRef.hide()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">My Account</h4>
</div>

<div class="modal-body">
  <h4>My Avatar</h4>
  <div class="form-group text-center">
    <image-cropper
      *ngIf="imageChangedEvent != null"
      [imageChangedEvent]="imageChangedEvent"
      format="png"
      (imageCropped)="imageCropped($event)"
      (imageLoaded)="imageLoaded()"
      (cropperReady)="cropperReady()"
      (loadImageFailed)="loadImageFailed()"
      [maintainAspectRatio]="true"
      [containWithinAspectRatio]="false"
      [aspectRatio]="1 / 1"
      [resizeToWidth]="150"
      [cropperMinWidth]="128"
      [onlyScaleDown]="true"
      [alignImage]="'left'"
      [output]="'base64'"
      [roundCropper]="true"
      format="png"
    ></image-cropper>
    <div class="loading-avatar" *ngIf="showLoading"></div>
    <img [src]="croppedImage" hidden width="150" height="150" />
    <label class="change-avatar-wrapper" *ngIf="imageChangedEvent == null">
      <img
        *ngIf="data.pictureUrl != null"
        [src]="data.pictureUrl"
        width="150"
        height="150"
      />
      <input
        type="file"
        accept=".pdf,.doc,.docx,.pptx,.ppt,.xls,.xlsx,.csv,.txt,.rtf,.html,.zip,.mp3,.wma,.mpg,.flv,.avi,.jpg,.jpeg,.png,.gif,.iif"
        (change)="fileChangeEvent($event)"
      />
    </label>
  </div>
  <button
    *ngIf="imageChangedEvent != null"
    class="btn btn-primary btn-lg"
    (click)="savePicture()"
    [disabled]="croppedImage == null"
  >
    Save Picture
  </button>
  <button
    style="margin-left: 15px"
    *ngIf="imageChangedEvent != ''"
    class="btn btn-default btn-lg"
    (click)="imageChangedEvent = ''"
  >
    Cancel
  </button>

  <hr />
  <h4>Login Details</h4>
  <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <label for="EmailInput">Email address</label>
        <input
          type="text"
          readonly
          class="form-control"
          [(ngModel)]="user.email"
        />
      </div>
    </div>
    <div class="col-sm-6" *ngIf="!updatingPassword">
      <div class="form-group">
        <label for="Password000Input">Password</label>
        <div class="input-group">
          <input
            id="Password000Input"
            type="password"
            class="form-control"
            readonly
            value="justaplaceholder"
          />
          <div class="input-group-addon">
            <a (click)="updatingPassword = true">Change</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <h4 *ngIf="phone_info.is_phone_number_verified">Two-Factor Authentication</h4>
  <div class="row">
    <div class="col-md-6" *ngIf="phone_info.is_phone_number_verified">
      <div class="form-group">
        <label for="PhoneNumber">Phone Number</label>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="phone_info.phone_number"
            readonly
          />
          <div class="input-group-addon">
            <a (click)="openSmsVerificationModal()">Change</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" style="margin-bottom: 15px">
    <div class="col-md-12">
      <div class="form-group">
        <button
          class="btn btn-primary btn-block pull-left"
          (click)="openSmsVerificationModal()"
          *ngIf="!phone_info.is_phone_number_verified"
        >
          Add Two-Factor Authentication (2FA)
        </button>
      </div>
    </div>
  </div>

  <!-- <div class="row">
    <div class="col-sm-6">
      <div class="form-group">
        <label for="PhoneNumber">Phone Number</label>
        <international-phone-number [(ngModel)]="data.phone_number" placeholder="Enter phone number" [maxlength]="20" [defaultCountry]="'us'" [required]="true" #phoneNumber="ngModel" name="phone_number"></international-phone-number>
      </div>
    </div>

    <div class="col-sm-4">
      <div class="form-group">
        <label for="VerificationCode">Verification Code</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="verificationCode"
        />
      </div>
    </div>
    <div class="col-sm-2">
      <button
      class="btn btn-primary btn-lg pull-left"
      (click)="verifySmsCode()"
      
    >
      Verify
    </button>
    </div>
    
  </div> -->
  <div class="my-account-change-password" *ngIf="updatingPassword">
    <p>
      <strong
        >Your password must contain capital and lower-case letters, symbols,
        numbers and at least 8 characters.</strong
      >
    </p>
    <form [formGroup]="passwordForm">
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group">
            <label for="Password000Input">Current Password</label>
            <div class="input-password">
              <input
                id="Password000Input"
                formControlName="currentPassword"
                type="password"
                class="form-control"
                placeholder="Current Password"
              />
              <i class="feather eye-off"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="Password111Input">New Password</label>
            <div class="input-password">
              <input
                id="Password111Input"
                type="password"
                formControlName="newPassword"
                class="form-control"
                placeholder="New Password"
              />
              <i class="feather eye-off"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group">
            <label for="Password222Input">Password Confirmation</label>
            <div class="input-password">
              <input
                id="Password222Input"
                type="password"
                formControlName="confirmPassword"
                class="form-control"
                placeholder="Password Confirmation"
              />
              <i class="feather eye-off"></i>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <button
    class="btn btn-default btn-lg pull-left"
    (click)="updatingPassword = false; bsModalRef.hide()"
  >
    Cancel
  </button>
  <button class="btn btn-primary btn-lg pull-right" (click)="changePassword()">
    Save
  </button>
  <br style="clear: both" />

  <!-- <div class="row">
            <div class="col-sm-12">
                <div class="form-group">
                    <label for="TimeZoneInput">Time zone</label>
                    <select class="form-control">
                        <option value="-12">(GMT-12:00) International Date Line West</option>
                        <option value="-11">(GMT-11:00) Midway Island, Samoa</option>
                        <option value="-10">(GMT-10:00) Hawaii</option>
                        <option value="-9">(GMT-09:00) Alaska</option>
                        <option value="-8">(GMT-08:00) Pacific Time (US & Canada)</option>
                        <option value="-8">(GMT-08:00) Tijuana, Baja California</option>
                        <option value="-7">(GMT-07:00) Arizona</option>
                        <option value="-7">(GMT-07:00) Chihuahua, La Paz, Mazatlan</option>
                        <option value="-7">(GMT-07:00) Mountain Time (US & Canada)</option>
                        <option  value="-6">(GMT-06:00) Central America</option>
                        <option  value="-6">(GMT-06:00) Central Time (US & Canada)</option>
                        <option  value="-6">(GMT-06:00) Guadalajara, Mexico City, Monterrey</option>
                        <option  value="-6">(GMT-06:00) Saskatchewan</option>
                        <option  value="-5">(GMT-05:00) Bogota, Lima, Quito, Rio Branco</option>
                        <option  value="-5">(GMT-05:00) Eastern Time (US & Canada)</option>
                        <option  value="-5">(GMT-05:00) Indiana (East)</option>
                        <option  value="-4">(GMT-04:00) Atlantic Time (Canada)</option>
                        <option  value="-4">(GMT-04:00) Caracas, La Paz</option>
                        <option  value="-4">(GMT-04:00) Manaus</option>
                        <option  value="-4">(GMT-04:00) Santiago</option>
                        <option  value="-3.5">(GMT-03:30) Newfoundland</option>
                        <option  value="-3">(GMT-03:00) Brasilia</option>
                        <option  value="-3">(GMT-03:00) Buenos Aires, Georgetown</option>
                        <option  value="-3">(GMT-03:00) Greenland</option>
                        <option  value="-3">(GMT-03:00) Montevideo</option>
                        <option  value="-2">(GMT-02:00) Mid-Atlantic</option>
                        <option  value="-1">(GMT-01:00) Cape Verde Is.</option>
                        <option  value="-1">(GMT-01:00) Azores</option>
                        <option  value="0">(GMT+00:00) Casablanca, Monrovia, Reykjavik</option>
                        <option  value="0">(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London</option>
                        <option  value="1">(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna</option>
                        <option  value="1">(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague</option>
                        <option  value="1">(GMT+01:00) Brussels, Copenhagen, Madrid, Paris</option>
                        <option  value="1">(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb</option>
                        <option  value="1">(GMT+01:00) West Central Africa</option>
                        <option  value="2">(GMT+02:00) Amman</option>
                        <option  value="2">(GMT+02:00) Athens, Bucharest, Istanbul</option>
                        <option  value="2">(GMT+02:00) Beirut</option>
                        <option  value="2">(GMT+02:00) Cairo</option>
                        <option  value="2">(GMT+02:00) Harare, Pretoria</option>
                        <option  value="2">(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius</option>
                        <option  value="2">(GMT+02:00) Jerusalem</option>
                        <option  value="2">(GMT+02:00) Minsk</option>
                        <option  value="2">(GMT+02:00) Windhoek</option>
                        <option  value="3">(GMT+03:00) Kuwait, Riyadh, Baghdad</option>
                        <option  value="3">(GMT+03:00) Moscow, St. Petersburg, Volgograd</option>
                        <option value="3">(GMT+03:00) Nairobi</option>
                        <option value="3">(GMT+03:00) Tbilisi</option>
                        <option value="3.5">(GMT+03:30) Tehran</option>
                        <option value="4">(GMT+04:00) Abu Dhabi, Muscat</option>
                        <option value="4">(GMT+04:00) Baku</option>
                        <option value="4">(GMT+04:00) Yerevan</option>
                        <option value="4.5">(GMT+04:30) Kabul</option>
                        <option value="5">(GMT+05:00) Yekaterinburg</option>
                        <option value="5">(GMT+05:00) Islamabad, Karachi, Tashkent</option>
                        <option value="5.5">(GMT+05:30) Sri Jayawardenapura</option>
                        <option value="5.5">(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi</option>
                        <option value="5.75">(GMT+05:45) Kathmandu</option>
                        <option value="6">(GMT+06:00) Almaty, Novosibirsk</option>
                        <option value="6">(GMT+06:00) Astana, Dhaka</option>
                        <option value="6.5">(GMT+06:30) Yangon (Rangoon)</option>
                        <option value="7">(GMT+07:00) Bangkok, Hanoi, Jakarta</option>
                        <option value="7">(GMT+07:00) Krasnoyarsk</option>
                        <option value="8">(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi</option>
                        <option value="8">(GMT+08:00) Kuala Lumpur, Singapore</option>
                        <option value="8">(GMT+08:00) Irkutsk, Ulaan Bataar</option>
                        <option value="8">(GMT+08:00) Perth</option>
                        <option value="8">(GMT+08:00) Taipei</option>
                        <option value="9">(GMT+09:00) Osaka, Sapporo, Tokyo</option>
                        <option value="9">(GMT+09:00) Seoul</option>
                        <option value="9">(GMT+09:00) Yakutsk</option>
                        <option value="9.5">(GMT+09:30) Adelaide</option>
                        <option value="9.5">(GMT+09:30) Darwin</option>
                        <option value="10">(GMT+10:00) Brisbane</option>
                        <option value="10">(GMT+10:00) Canberra, Melbourne, Sydney</option>
                        <option value="10">(GMT+10:00) Hobart</option>
                        <option value="10">(GMT+10:00) Guam, Port Moresby</option>
                        <option value="10">(GMT+10:00) Vladivostok</option>
                        <option value="11">(GMT+11:00) Magadan, Solomon Is., New Caledonia</option>
                        <option value="12">(GMT+12:00) Auckland, Wellington</option>
                        <option value="12">(GMT+12:00) Fiji, Kamchatka, Marshall Is.</option>
                        <option value="13">(GMT+13:00) Nuku'alofa</option>
                    </select>
                </div>
            </div>
        </div> -->
</div>
